export default "__VITE_ASSET__f0100efc__"